import Navbar from "../Layout/Navbar";
import Hero from "../components/Homepage/Hero";
import Intro from "../components/Homepage/Intro";
import Services from "../components/Homepage/Services";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import WorkshopHero from "components/Homepage/WorkshopHero";
import Mentorship from "../components/Homepage/Mentorship";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import AnimationCounter from "components/Homepage/AminationCouter";
import Testimonial from "components/Client&Partner/Testimonial";
import SocialMedia from "components/About/SocialMedia";
import ReadyToGrow from "components/Homepage/ReadyToGrow";
import UpcomingEvent from "components/Homepage/UpcomingEvent";

const HomePage = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    }
  }, [hash]);

  return (
    <div className="bg-darkbg text-white">
      {/* <Hero /> */}
      <Intro />
      <Services />
      <AnimationCounter />
      <Mentorship />
      <div id="latestworkshop">
        {/* <LatestWorkshop /> */}
        <UpcomingEvent />
      </div>
      <div id="successstories">
        <Testimonial />
      </div>{" "}
      <ReadyToGrow />
      {/* <SocialMedia /> */}
    </div>
  );
};

export default HomePage;
